import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/40 bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-62" data-mp="15bsp5nr0okn9">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-63" data-mp="1jbad60whntvk">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-64" data-mp="1eetpf7t7bhj0">
          <span className="inline-flex items-center gap-2" data-id="element-65" data-mp="1t252xf8y1blr">
            <GlobeIcon className="glow-led h-8 w-8 shrink-0 text-highlight" aria-hidden="true" data-id="element-66" data-mp="1o3lgzeucnzte" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-2xl" data-id="element-67" data-mp="2245xu5gpflk9">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-68" data-mp="n6e4lks7mfvu">
          Created for science, earth science, environmental science and geography teachers — middle school, high school,
          introductory college and homeschool.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-8 w-full sm:w-auto" data-id="element-69" data-mp="122vd8490lgep">
          Get my Teacher Ready collection now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-70" data-mp="1b3a2fep3nfnh">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-71" data-mp="1fvl00awdapcv">
              <CheckIcon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-72" data-mp="1ktw7wg33qpsg" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}